import { Card, RadioSet, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import { type Settings, useSettings, useUpdateSettings } from '../../../context/settings-context';

type Strategy = NonNullable<Settings['shippingAutoSelectionStrategy']>;

const KEY = 'features:shipping_methods.components.shipping_auto_selection_card';

export function ShippingAutoSelectionCard() {
  const { notificationHandler } = useHandlers();
  const settings = useSettings();
  const updateSetting = useUpdateSettings();

  function setStrategy(value: Strategy) {
    updateSetting.mutate(
      { key: 'shippingAutoSelectionStrategy', value },
      {
        onError: () => {
          notificationHandler.error();
        },
      },
    );
  }

  return (
    <Card>
      <Card.Header headingLevel="h2">{t(`${KEY}.title`)}</Card.Header>
      <Card.Body>
        <Text variant="secondary">{t(`${KEY}.description`)}</Text>
        <RadioSet<Strategy>
          name="shippingAutoSelectionStrategy"
          value={settings.shippingAutoSelectionStrategy ?? 'first_available'}
          onChange={setStrategy}
          options={[
            {
              value: 'first_available',
              label: t(`${KEY}.options.first_available.label`),
              description: t(`${KEY}.options.first_available.description`),
            },
            {
              value: 'cheapest_non_free',
              label: t(`${KEY}.options.cheapest_non_free.label`),
              description: t(`${KEY}.options.cheapest_non_free.description`),
            },
          ]}
        />
      </Card.Body>
    </Card>
  );
}
